export default __webpack_public_path__ + "static/pragicts-itops-it-asset-management-f05a3a1f4400e33879c9ac7bb3d1635e.jpg";